<template>
    <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="data-table__head">
            <div class="data-table-sort">
              <p>Pokaż</p>
              <select v-model="perPage" @change="perPageChange()">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <p>pozycji</p>
            </div>
            <div class="button-group">
              <span class="button-module-table" @click="$router.push('/user/add');">
                <svg xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="0 0 448 448" width="512px">
                  <g>
                    <path d="m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  </g>
                </svg>
                <p>Dodaj użytkownika</p>
              </span>
            </div>
        </div>
        <b-container fluid>
            <!-- Main table element -->
          <div class="table--wrapper">
            <b-table
              class="app-table users-table"
              show-empty
              stacked="md"
              striped
              :busy="isBusy"
              :items="items"
              :fields="fields"
              :paginated="false"
              :backend-sorting="true"
              @filtered="onFiltered"
              hover>

              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              <template slot="HEAD_name" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'name'}" @click="sortDir('name')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'name'"></div>
                </label>
                <input class="form-control form-control-lg" type="text" v-model="searchUser" @input="splitValue(); searching()"/>
                </div>
              </template>

              <template slot="HEAD_email" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'email'}" @click="sortDir('email')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'email'"></div>
                </label>
                <input class="form-control form-control-lg" type="text" v-model="search.email" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_company" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'company'}" @click="sortDir('company')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'company'"></div>
                </label>
                <select class="form-control form-control-lg" v-model="search.company" @input="searching()">
                  <option value=""></option>
                  <option v-for="company in companiees" :key="company.id" :value="company.id">{{company.name}}</option>
                </select>
                </div>
              </template>

              <template slot="HEAD_roles" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'roles'}" @click="sortDir('roles')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'roles'"></div>               
                </label>
                <select class="form-control form-control-lg" v-model="search.roles" @input="searching()">
                  <option value=""></option>
                  <option v-for="role in roles" :key="role.id" :value="role.id">{{role.name}}</option>
                </select>
                </div>
              </template>

              <template slot="HEAD_category" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'category'}" @click="sortDir('category')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'category'"></div>                 
                </label>
                <select class="form-control form-control-lg" v-model="search.category" @input="searching()">
                  <option value=""></option>
                  <option v-for="category in categories" :key="category.id" :value="category.id">{{category.name}}</option>
                </select>
                </div>
              </template>

              <template slot="HEAD_parentMarket" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'parentMarket'}" @click="sortDir('parentMarket')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'parentMarket'"></div>                  
                </label>
                <input class="form-control form-control-lg" type="text" v-model="search.parentMarketStr" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_lastActivity" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'lastLogin'}" @click="sortDir('lastLogin')">
                  {{ data.label }}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'lastLogin'"></div>
                </label>
                <input class="form-control form-control-lg" type="text" v-model="search.lastLogin" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_clear" slot-scope="data">
                <div class="form-group">
                  <div class="button-group">
                    <span class="button-normal button-normal--clear" @click="clearSearch()"><img src="../../assets/symbols/iks.svg" /></span>
                  </div>
                </div>
              </template>

              <template slot="name" slot-scope="row">
                <router-link class="select-link" data-tooltip="Edytuj" :to="{ name: 'UserEdit', params: { id: row.item.id, name: row.item.name, surname: row.item.surname }}">{{row.item.name}} {{row.item.surname}}</router-link>
              </template>

              <template slot="company" slot-scope="row">
                {{row.item.company.name}}
              </template>

              <template slot="roles" slot-scope="row">
                <b-badge class="badge" :class="{
                  'badge-red-user' : row.item.roles[0] == 'ROLE_SUPER_ADMIN' || row.item.roles[0] == 'ROLE_ADMIN',
                  'badge-navy-user' : row.item.roles[0] == 'ROLE_COORDINATOR',
                  'badge-green-user' : row.item.roles[0] == 'ROLE_LOCAL',
                  'badge-violet-user' : row.item.roles[0] == 'ROLE_EDITOR',
                  'badge-blue-user' : row.item.roles[0] == 'ROLE_CENTRAL',
                  'badge-disabled-user' : !row.item.enabled,
                  }">{{ row.item.enabled ? $parent.translate(row.item.roles[0]) : 'nieaktywny' }}</b-badge>
              </template>

              <template slot="category" slot-scope="row">
                {{row.item.category.name}}
              </template>

              <template slot="parentMarket" slot-scope="row">
                <div v-if="row.item.parent_market">{{row.item.parent_market.sapNumber}} {{row.item.parent_market.gallery_city}} {{row.item.parent_market.number}} {{row.item.parent_market.gallery}} {{row.item.parent_market.category.name}}</div>
              </template>

              <template slot="lastActivity" slot-scope="row">
                {{row.item.last_login}}
              </template>

            </b-table>
          </div>
        </b-container>
        <b-row>
            <b-col class="my-1">
              <b-pagination
                v-if="!items.length == 0"
                v-model="currentPage"
                 :total-rows="totalRows"
                :per-page="perPage"
                class="my-0 float-right"
                @change="pageChange">
              </b-pagination>
            </b-col>
          </b-row>
      </div>
  </div>

</template>

<script>

import debounce from "lodash.debounce";

export default {

  name: 'Dashboard',
  data () {

    return {

      title: 'Lista użytkowników',

      isBusy: false,
      fields: [

          {
            key: 'name', 
            label: 'Imię i nazwisko' 
          },
          {
            key: 'email', 
            label: 'Adres e-mail' 
          },
          {
            key: 'company', 
            label: 'Nazwa firmy' 
          },
          {
            key: 'roles', 
            label: 'Uprawnienia' 
          },
          {
            key: 'category', 
            label: 'Kategoria' 
          },
          {
            key: 'parentMarket', 
            label: 'Market macierzysty' 
          },
          {
            key: 'lastActivity', 
            label: 'Ostatnia aktywność' 
          },
          {
            key: 'clear', 
            label: '' 
          },

        ],

      items: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      offset: 0,
      sort: false,
      sortDirection: 'ASC',
      sortField: 'name',

      searchUser: '',
      
      search:{
        name: '',
        surname: '',
        email: '',
        company: '',
        roles: '',
        category: '',
        parentMarketStr: '',
        lastLogin: ''
      },

      companiees:[],
      categories:[],
      roles:[],
    
    }

  },
  methods:{

    getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('users/form/data', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }})
        .then(response => {

          let companiees  = response.data.company;
          let categories  = response.data.category;
          let roles       = response.data.role;

          console.log(response)
          
          companiees.forEach((item)=>{
            this.companiees.push({id: item.id, name: item.name});
          });

          categories.forEach((item)=>{
            this.categories.push({id: item.code, name: item.name});
          });

          roles.forEach((item)=>{
            this.roles.push({id: item.id, name: item.name});
          });
              
        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    sortDir(field){

      if(field != this.sortField){

        this.sortField = field; 
        this.sortDirection = 'ASC',

        this.getUsers();

        return;

      }
      
      this.sortDirection == 'DESC' ? this.sortDirection = 'ASC' : this.sortDirection = 'DESC';
      this.sortField = field; 
      this.getUsers();

    },

    splitValue(){

        let data = this.searchUser;

        if (/\s/.test(data)) {

          data = data.split(' ');
          
          this.search.name = data[0];
          this.search.surname = data[1];

        }else{

          this.search.name = data;
          //this.search.surname = data;

        }

    },

    searching: debounce(function(){

      this.currentPage = 1;
      this.offset = 0;
      this.getUsers();

    }, 500),

    clearSearch(){

      this.searchUser = '';
      this.search.name =  '';
      this.search.surname =  '';
      this.search.email =  '';
      this.search.company =  '';
      this.search.roles =  '';
      this.search.category =  '';
      this.search.parentMarketStr =  '';
      this.search.lastLogin =  ''
      this.sortField = 'name'; 
      this.sort = false;
      this.sortDirection = 'ASC';

      this.getUsers();

    },

    getUsers(){

      const token = localStorage.getItem('auth_token');
      this.isBusy = true;

      let request={
        'limit' : parseInt(this.perPage),
        'offset' : this.offset,
        'sort' : this.sortDirection,
        'sort_field' : this.sortField
      }
      
      const entries = Object.entries(this.search);

      for (const [key, value] of entries) {
        
        if(value != ''){
          request[key] = value;
        }

      }

      this.$http.get('users/users', {
        params:request,
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }}).then(response => {

          this.isBusy = false;
          this.items = response.data.list;
          this.totalRows = response.data.total;

        })
        .catch(error =>{
          
          if (error.response.status === 400 || error.response.status === 401 || error.response.status === 402) {
            
            this.$router.push('/');

          } else {

            console.error(error.response);
            this.loading = false;

          }

        })

    },

    

    pageChange (page) {
      this.currentPage = page
      this.offset = ((this.currentPage - 1) * this.perPage)
      this.getUsers() 
    },

    perPageChange () {
      this.perPage = parseInt(this.perPage);
      this.currentPage = 1;
      this.offset = 0;
      this.getUsers();
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    userSelected(id) {

      this.$router.push(`/user/${id}`);
    
    }

  },
  computed:{

    sortOptions() {

      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
         })
    }

  },
  mounted(){

    this.getFormData();
    this.getUsers();
    this.totalRows = this.items.length

  }
};
</script>
